import { ApiLocation, LocationType } from "../services/api"

export const buoys: ApiLocation[] = [
    {
        type: LocationType.Buoy,
        ID: "CRESTBUOY3",
        siteName: "FIU CREST 3",
        gCoord: {x: 25.846355032311543, y: -80.17689585781098},
        siteDescription: "Deployed in response to low-oxygen conditions, this buoy monitors water quality and flow from the Little River into Biscayne Bay. Located near Little River Pocket Park, it helps detect early changes in local water conditions.",
    },    
    {
        type: LocationType.Buoy,
        ID: "DB600s32256",
        siteName: "FIU CREST 4",
        gCoord: {x: 25.7836199, y: -80.218342},
        siteDescription: "Installed in early 2020, this buoy monitors conditions in the heavily polluted Miami River. It collects and transmits data every 15 minutes, including temperature, salinity, dissolved oxygen, and water flow.",
    },      
    {
        type: LocationType.Buoy,
        ID: "FIUCREST5",
        siteName: "FIU CREST 5",
        gCoord: {x: 25.72695, y: -80.26966},
        siteDescription: "Operating since 2019, this is the longest-running buoy site in the Coral Gables Waterway. It monitors water quality and flow to compare typical conditions with extreme events like heavy rain and king tides.",
    },         
    {
        type: LocationType.Buoy,
        ID: "DB600-35013",
        siteName: "Haulover Inlet",
        gCoord: {x: 25.90303, y: -80.13295},
        siteDescription: "DB600+EXO2",
    },      
    {
        type: LocationType.Buoy,
        ID: "DB600sn34439",
        siteName: "Kampong",
        gCoord: {x: 25.71401222268680, y: -80.24839167054748},
        siteDescription: "DB600+Exo2",
    },  
    {
        type: LocationType.Buoy,
        ID: "DB600-32239",
        siteName: "Royal Castle / Singer",
        gCoord: {x: 25.871404913060736, y: -80.17398},
        siteDescription: "Funded by Royal Castle Companies and Singer Management, this buoy monitors the Biscayne Canal, a key data gap identified after the 2020 fish kill. Installed in 2023, it tracks water quality and flow into northern Biscayne Bay using a compact, energy-efficient design.",
    },  
]